define('superAdminMbAnasView',[
    'module',
    'marionette',
    'underscore',
    'app',
    'settings',
    'jqgridView',
    'template!superAdminMbAnasListTpl'
], function (
    module,
    Marionette,
    _,
    App,
    Settings,
    JqGridView,
    viewTpl
    ) {
    'use strict';

    var MbAnaListView = JqGridView.extend({
        template: viewTpl,
        filtersName: 'mbanasListFilters',

        triggers: {
        },

        ui: function() {
            return _.extend({
                jqGrid: '#jq-grid-list',
                jqGridPager: '#jq-grid-pager-list',
                deleteMbAna: '.delete-mbana-link'
            }, this.gridUi);
        },

        events: function() {
            return _.extend({
                'click @ui.deleteMbAna': 'onDeleteMbAna'
            }, this.gridEvents);
        },

        serializeData: function() {
            var templateData = {type: 'mbanas'};

            return templateData;
        },

        pagination: function() {
            return {
                first: 0,
                rowCount: 0,
                pageSize: Settings.get('perPage15'),
                currentPage: 1
            };
        },

        onDeleteMbAna: function(event){
            this.trigger('mbana:delete', $(event.currentTarget).find('span').attr('data-row-id'));
        },

        gridOptions: function(data) {
            var options = {
                colModel: [
                    {
                        label: '',
                        name: 'secId',
                        key: true,
                        hidden: true
                    }, {
                        label: _.i18n('common.code'),
                        name: 'code',
                        classes: 'mbana-link',
                        formatter:  this.defaultFormatter,
                        search: true,
                        index: 'code',
                        width: 45
                    }, {
                        label: _.i18n('common.name'),
                        name: 'name',
                        classes: 'mbana-link',
                        formatter:  this.defaultFormatter,
                        search: true,
                        index: 'name'
                    }, {
                        label: _.i18n('mbana.refMbAnaResGr'),
                        name: 'refMbAnaResGr.code',
                        classes: 'mbana-link',
                        formatter:  this.defaultFormatter,
                        search: false,
                        index: 'refMbAnaResGr.code'
                    }, {
                        label: _.i18n('mbana.typeTarget'),
                        name: 'typeTarget',
                        classes: 'mbana-link',
                        formatter:  this.typeTargetFormatter,
                        search: false,
                        index: 'typeTarget'
                      }, {
                        label: _.i18n('mbana.infectionType'),
                        name: 'infectionType',
                        classes: 'mbana-link',
                        formatter:  this.infectionTypeFormatter,
                        search: false,
                        index: 'infectionType'
                    }, {
                        label: ' ',
                        name: 'delete',
                        search: false,
                        classes: 'delete-mbana-link delete-link',
                        formatter: this.deleteIconFormatter,
                        width: 20
                    }
                ],

                onSelectRow: function(rowId, bool, e) {
                    if (!$(e.target).hasClass('cell-delete') && e.type === 'click') {
                        if (e.type === 'click') {
                            var route = App.getCurrentRoute() ===  'superAdmin/mbanas' ?
                                App.getCurrentRoute() : 'superAdmin/mbanas/' + App.getCurrentRoute();
                            App.navigate(route + '/' + rowId, {trigger: true});
                        }
                    }
                }
            };

            options = _.defaults(options, this.gridInitOptions(data));

            return options;
        },

        infectionTypeFormatter: function(cellValue, options) {
            if (cellValue) {
              cellValue = _.i18n('mbana.infectionType.' + cellValue.toLowerCase());
            } else {
                cellValue = '';
            }
            return '<span class="cell-default" data-row-id="' +
              options.rowId + '">' + cellValue + '</span>';
        },

        typeTargetFormatter: function(cellValue, options) {
            if (cellValue) {
              cellValue = _.i18n('mbana.typeTarget.' + cellValue.toLowerCase());
            } else {
              cellValue = '';
            }
            return '<span class="cell-default" data-row-id="' +
              options.rowId + '">' + cellValue + '</span>';
        }
    });

    module.exports = MbAnaListView;
});
